'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_DocumentsListRequest(pageCursor, kinds) {
  this.a6S = null;
  this.a6R = null;
  this.a6S = pageCursor;
  this.a6R = kinds;
}
export { $c_Lapp_api_DocumentsListRequest as $c_Lapp_api_DocumentsListRequest };
$p = $c_Lapp_api_DocumentsListRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_DocumentsListRequest;
/** @constructor */
function $h_Lapp_api_DocumentsListRequest() {
}
export { $h_Lapp_api_DocumentsListRequest as $h_Lapp_api_DocumentsListRequest };
$h_Lapp_api_DocumentsListRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DocumentsListRequest)) {
    var x = this.a6S;
    var x$2 = x$0.a6S;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.a6R;
      var x$4 = x$0.a6R;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentsListRequest";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.a6S;
  }
  if ((n === 1)) {
    return this.a6R;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "pageCursor";
  }
  if ((n === 1)) {
    return "kinds";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_DocumentsListRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iq)));
}
export { $isArrayOf_Lapp_api_DocumentsListRequest as $isArrayOf_Lapp_api_DocumentsListRequest };
var $d_Lapp_api_DocumentsListRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_DocumentsListRequest, "app.api.DocumentsListRequest", ({
  iq: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_DocumentsListRequest as $d_Lapp_api_DocumentsListRequest };
//# sourceMappingURL=app.api.-Documents-List-Request.js.map
